import React, {useState, useEffect} from "react";
import { GatsbyImage, StaticImage } from "gatsby-plugin-image";
import '../../sass/components/flexibleModules/_components.fullWidthTestimonialModuleComponent.scss';
import Slider from "react-slick"
import "../../sass/slick/slick.min.scss"
import "../../sass/slick/slick-theme.min.scss"

const FullWidthTestimonialCarouselComponent = ({ data }) => {

    const [isRendered, setIsRendered] = useState(false)

    let settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
        centerMode: false,
        swipeToSlide: true,
        touchThreshold: 250,
        adaptiveHeight: false
    }

    useEffect(() => {
        setIsRendered(true)
    }, [])

    return (
        <div className="cp-fullWidthTestimonialModuleComponent" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-fullWidthTestimonialModuleComponent__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.fullWidthTestimonialModuleCarouselHeader &&
                    <h2>{data.fullWidthTestimonialModuleCarouselHeader}</h2>
                }
                {data.fullWidthTestimonialModuleCarouselLink && 
                    <a className="l-textlink" href={data.fullWidthTestimonialModuleCarouselLink.url} target={data.fullWidthTestimonialModuleCarouselLink.target}>
                        <span>{data.fullWidthTestimonialModuleCarouselLink.title}</span>
                        <StaticImage src="../../images/arrow-right-blue-textlink.svg" alt="" />
                    </a>   
                }
                {data.fullWidthTestimonialModuleLogoCarousel &&
                    <>
                        {isRendered && (
                            <Slider {...settings}>
                                {data.fullWidthTestimonialModuleLogoCarousel.map((testimonialCarousel, index) => (
                                    <div className="l-testimonialCarousel" key={index}>
                                        {testimonialCarousel.fullWidthTestimonialModuleLogo &&
                                            <img loading="lazy" src={testimonialCarousel.fullWidthTestimonialModuleLogo.sourceUrl} alt={testimonialCarousel.fullWidthTestimonialModuleLogo.altText} />
                                        }
                                        {testimonialCarousel.fullWidthTestimonialModuleTestimonial &&
                                            <h2 dangerouslySetInnerHTML={{__html: testimonialCarousel.fullWidthTestimonialModuleTestimonial}} />
                                        }
                                        {testimonialCarousel.fullWidthTestimonialModuleAuthorThumb &&
                                            <GatsbyImage image={testimonialCarousel.fullWidthTestimonialModuleAuthorThumb.gatsbyImage} alt={testimonialCarousel.fullWidthTestimonialModuleAuthorThumb.altText} />
                                        }
                                        {testimonialCarousel.fullWidthTestimonialModuleAuthorName &&
                                            <h5 className="cp-fullWidthTestimonialModuleComponent__authorName">{testimonialCarousel.fullWidthTestimonialModuleAuthorName}</h5>
                                        }
                                        {testimonialCarousel.fullWidthTestimonialModuleAuthorTitle &&
                                            <p className="cp-fullWidthTestimonialModuleComponent__authorTitle">{testimonialCarousel.fullWidthTestimonialModuleAuthorTitle}</p>
                                        }
                                    </div>
                                ))}
                            </Slider>
                        )}
                    </>
                }
            </div>
        </div>
    );
}

export default FullWidthTestimonialCarouselComponent;